import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const EmpresaService = {
    getEmpresas: async () => {
        try {
            const response = await getAxios().get('/api/empresas');
            return response.data?.data ?? [];
        } catch (error) {
            // Fallback para mantener operativa la pantalla cuando falle el endpoint autenticado.
            const publicResponse = await getAxios().get('/api/empresas/public');
            const empresaPublica = publicResponse.data?.data;
            return empresaPublica ? [empresaPublica] : [];
        }
    },

    getPublicInfo: async () => {
        const response = await getAxios().get('/api/empresas/public');
        return response.data?.data ?? null;
    },

    getEmpresaById: async (id) => {
        const response = await getAxios().get(`/api/empresas/${id}`);
        return response.data?.data ?? null;
    },

    crearEmpresa: async (empresa) => {
        const response = await getAxios().post('/api/empresas', empresa);
        return response.data?.data;
    },

    actualizarEmpresa: async (id, empresa) => {
        const response = await getAxios().put(`/api/empresas/${id}`, empresa);
        if (response.data && response.data.success === false) {
            throw new Error(response.data.message || "Error al actualizar");
        }
        return response.data?.data;
    },

    uploadLogo: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await getAxios().post(`/api/empresas/${id}/logo`, formData);

        return response.data?.data;
    },

    uploadCertificado: async (id, file, password, usuarioSol, claveSol, modo) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('password', password);
        formData.append('usuarioSol', usuarioSol);
        formData.append('claveSol', claveSol);
        formData.append('modo', modo);

        const response = await getAxios().post(`/api/empresas/${id}/certificado`, formData);

        return response.data?.data;
    },

    /**
     * Obtiene el estado de configuración SUNAT (sin exponer credenciales)
     * Retorna indicadores de qué está configurado
     */
    obtenerEstadoSunat: async (id) => {
        try {
            const response = await getAxios().get(`/api/empresas/${id}/sunat-config`);
            return response.data?.data ?? null;
        } catch (error) {
            console.error('Error obteniendo estado SUNAT:', error);
            return null;
        }
    },

    /**
     * Actualiza la configuración SUNAT sin cargar certificado
     * Permite cambiar usuario, clave, contraseña cert y modo
     */
    actualizarConfigSunat: async (id, config) => {
        try {
            const response = await getAxios().put(`/api/empresas/${id}/sunat-config`, config);
            return response.data?.data;
        } catch (error) {
            console.error('Error actualizando configuración SUNAT:', error);
            throw error;
        }
    },

    // Alias para mantener consistencia con otros servicios del proyecto.
    getAll: async () => EmpresaService.getEmpresas(),
    getById: async (id) => EmpresaService.getEmpresaById(id),
    create: async (empresa) => EmpresaService.crearEmpresa(empresa),
    update: async (id, empresa) => EmpresaService.actualizarEmpresa(id, empresa),
    delete: async (id) => {
        const response = await getAxios().delete(`/api/empresas/${id}`);
        return response.data?.data;
    }
};
